<template>
  <div class="variation-selection-1">
    <span class="d-block mb-3 variation-selection-1-choose-feature"
          v-t="`product.single.variation_selection.choose_feature`"></span>
    <div v-for="(layer, layerIndex) in layers" :key="layerIndex" class="mb-6 border-b pb-4">
      <div class="font-weight-bold mb-2 variation-selection-1-feature-title">
        {{ layer[0]?.feature?.public_name ?? 'ویژگی' }}
      </div>

      <div class="flex flex-wrap gap-2 variation-selection-1-feature-items-wrapper">
        <button
            v-for="item in getUniqueAttributes(layer)"
            :key="item.feature_attribute_id + '-' + item.feature_id"
            @click="selectOption(layerIndex, item)"
            :class="[
            'btn mx-1 variation-selection-1-feature-item',
            isItemSelected(layerIndex,item) ? 'variation-selection-1-feature-item-active'
              : 'btn variation-selection-1-feature-item mx-1'
          ]">
          {{ item.feature_attribute?.value }}
        </button>
      </div>
    </div>

    <!-- نمایش عکس آیتم انتخاب شده -->
  <div class="wait-variation-icon-wrapper text-center d-flex align-items-center justify-content-center" v-if="!selectedItemImage">

    <i class="bi bi-card-image wait-variation-icon"></i>

  </div>
    <div v-if="selectedItemImage" class="mt-4 variation-img-wrapper-1">
      <img
          :src="selectedItemImage"
          alt="Selected item image"
          class="variation-img-1 img-fluid"
          :key="selectedItemImage"
          @load="onImageLoad"
      >
    </div>




    <div class="variation-selection-1-quantity-manager">
      <variation-quantity-manager1
          v-if="sub_product !=null"
          :product="product" :sub_product="sub_product"
          :sub_img_product_prop="false"

      />
    </div>
  </div>
</template>

<script>
import mA from "../../../../Tags/A.vue";
import mShoppingCartQuantityManager1 from "../../../ShoppingCartQuantityManager1.vue";
import {productFeatureName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import VariationQuantityManager1 from "../../../QuantityManager/Variation/VariationQuantityManager1.vue";

export default {
  name: "VariationSelection1",
  components: {VariationQuantityManager1, mShoppingCartQuantityManager1, mA},
  props: {
    product: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      layers: [],
      selected: {},
      sub_product: null,
      selectedItemImage: null // اضافه شده
    }
  },
  mounted() {
    this.loadInitialLayer()
  },
  methods: {
    findAttributeOnSiteInfo,
    productFeatureName,
    isItemSelected(layerIndex, item) {
      return this.selected[layerIndex]?.feature_attribute_id === item.feature_attribute_id &&
          this.selected[layerIndex]?.feature_id === item.feature_id
    },
    loadInitialLayer() {
      const rootItems = this.product.feature_product.filter(item => item.link_feature_id === null)
      this.layers = [rootItems]
    },
    getUniqueAttributes(layer) {
      const seen = new Set()
      return layer.filter(item => {
        const key = `${item.feature_id}-${item.feature_attribute_id}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    selectOption(layerIndex, selectedItem) {
      this.sub_product = null
      this.selected[layerIndex] = selectedItem

      // ذخیره عکس آیتم انتخاب شده
      this.selectedItemImage = selectedItem.image_url || selectedItem.image || selectedItem.photo_url // بسته به ساختار داده شما

      // حذف لایه‌های بعدی
      this.layers.splice(layerIndex + 1)
      this.selected = Object.fromEntries(
          Object.entries(this.selected).filter(([i]) => parseInt(i) <= layerIndex)
      )

      const parents = this.product.feature_product.filter(
          item =>
              item.feature_attribute_id === selectedItem.feature_attribute_id &&
              item.feature_id === selectedItem.feature_id
      )
      const parentIds = parents.map(p => p.id)

      const nextLayer = this.product.feature_product.filter(item =>
          parentIds.includes(item.link_feature_id)
      )

      if (!nextLayer.length > 0) {
        this.sub_product = this.selected[layerIndex]
      }

      if (nextLayer.length > 0) {
        this.layers.push(nextLayer)
      }
    },
    onImageLoad(e) {
      e.target.classList.add('loaded');
    },
  },
}
</script>

<style scoped>
.variation-selection-1-feature-item {
  border: 1px solid var(--primary);
  margin-bottom: 4px;
}

.variation-selection-1-feature-item-active {
  background: var(--primary);
}

.variation-img-1 {
  max-height: 250px;
  opacity: 0;
  transform: scale(0.95);
  transition:
      opacity 0.6s ease-out,
      transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  padding: 16px;
  border-radius: 44px;
}

.variation-img-1.loaded {
  opacity: 1;
  transform: scale(1);
}

.variation-img-wrapper-1 {
  height: 300px;
  text-align: center;
  overflow: hidden;
}

/* پیش‌لودر (اختیاری) */
.variation-img-wrapper-1::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  display: none;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.variation-img-wrapper-1.loading::before {
  display: block;
}

.wait-variation-icon-wrapper{
  height: 300px;
  text-align: center;
  overflow: hidden;

}

.wait-variation-icon{
  -webkit-filter: brightness(0) invert(.6);
  font-size: 80px;

}


</style>